import { render, staticRenderFns } from "./TrucksTable.vue?vue&type=template&id=172b8e1c&scoped=true"
import script from "./TrucksTable.vue?vue&type=script&lang=ts"
export * from "./TrucksTable.vue?vue&type=script&lang=ts"
import style0 from "./TrucksTable.vue?vue&type=style&index=0&id=172b8e1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172b8e1c",
  null
  
)

export default component.exports